import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I made a steampunk costume",
  "description": "",
  "published": "2012-02-23T00:00:00.000Z",
  "redirect_from": ["/blog/i-made-a-steampunk-costume/swizec/3729"],
  "categories": "Clothing, Costume, Shopping, Steampunk, Uncategorized, Victorian era",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Every couple of years I actively participate in our version of mardi gras and dress up in a costume. It's usually something mundane like dressing up as a living statue or a girl or whatever.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/tumblr_lzud2o2A4V1qekjngo1_5003.jpg",
        "alt": "Full costume",
        "title": "Full costume"
      }}></img></p>
    <p>{`This year, however, I decided to go full out. Finally, an excuse to make a steampunk costume!`}</p>
    <p>{`I'm not the handiest person in the world so the whole thing was a bit of a mess - not a single straight cut anywhere, parts of my room are now gold and there is trash everywhere. But I had a lot of fun working manually for two days. It's remarkably refreshing to do something in meatspace now and anon.`}</p>
    <p>{`All the manly work even made my fifth chest hair grow! Score!`}</p>
    <p>{`I'm quite pleased with the result, the costume turned out pretty decent and only cost about 30 euro in parts and another ~300 euro in time. Plus whatever old crap I found collecting dust around the house; like for instance, bits of my high school death metal outfit.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/tumblr_lzpj40CCuq1qekjngo1_5005.jpg",
        "alt": "It begins with a pile of junk",
        "title": "It begins with a pile of junk"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/tumblr_lzpnlcFYDv1qekjngo1_5004.jpg",
        "alt": "Regular welding glasses from a store, just added the fluff",
        "title": "Regular welding glasses from a store, just added the fluff"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/tumblr_lzpv4nKIQy1qekjngo1_5004.jpg",
        "alt": "First stage of shoulder armor - an old belt, strip of cloth and leather tied on with aluminium wire",
        "title": "First stage of shoulder armor - an old belt, strip of cloth and leather tied on with aluminium wire"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/tumblr_lzqox0thrJ1qekjngo1_5004.jpg",
        "alt": "The hat is actually something I always wear",
        "title": "The hat is actually something I always wear"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/photo1-1024x764.jpg",
        "alt": "Normal welding gloves and some wire",
        "title": "Normal welding gloves and some wire"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/photo-13-1024x764.jpg",
        "alt": "Took several tries to make symmetric wings",
        "title": "Took several tries to make symmetric wings"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/tumblr_lzqwrcTn2l1qekjngo1_5004.jpg",
        "alt": "The trick is to apply copper paint with a sponge",
        "title": "The trick is to apply copper paint with a sponge"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/tumblr_lzr07u1kEI1qekjngo1_5004.jpg",
        "alt": "Armor panels",
        "title": "Armor panels"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/tumblr_lzr4m789651qekjngo1_5004.jpg",
        "alt": "The finished shoulder armor drying ",
        "title": "The finished shoulder armor drying "
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/tumblr_lzr80yr3Lq1qekjngo1_5004.jpg",
        "alt": "The gloves turned out quite well",
        "title": "The gloves turned out quite well"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/photo-22-764x1024.jpg",
        "alt": "Manliest my desk has ever looked",
        "title": "Manliest my desk has ever looked"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/tumblr_lzud2o2A4V1qekjngo1_5003.jpg",
        "alt": "Slightly bigger picture of full outfit",
        "title": "Slightly bigger picture of full outfit"
      }}></img></p>
    <p>{`Unfortunately the costume did not prevent me from accidentally getting way too drunk at the party. Lost my real glasses, the hat, my keys, even my moleskine.`}</p>
    <p>{`All in all, the most expensive party I've ever been to ... but at least the costume is cool :)`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.winextra.com/2012/02/your-nerf-rifle-love-just-got-seriously-steampunked/"
        }}>{`Your NERF rifle love just got seriously steampunked`}</a>{` (winextra.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://geeks.thedailywh.at/2012/02/22/steampunk-nerf-gun-of-the-day/"
        }}>{`Steampunk Nerf Gun of the Day`}</a>{` (geeks.thedailywh.at)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://darkrosedesign.com/2012/02/15/steampunk-costume-update/"
        }}>{`Steampunk Costume Update`}</a>{` (darkrosedesign.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://mishidems.wordpress.com/2012/02/21/blast-from-the-past-steampunk/"
        }}>{`Blast from the Past: Steampunk`}</a>{` (mishidems.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://kasiajames.wordpress.com/2012/01/25/steampunk-moves-on/"
        }}>{`Steampunk moves on`}</a>{` (kasiajames.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://geektyrant.com/news/2011/12/19/awesome-steampunkd-disney-character-art.html"
        }}>{`Awesome Steampunk'd Disney Character Art!`}</a>{` (geektyrant.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://laughingsquid.com/the-steampunk-worlds-fair-2012/"
        }}>{`The Steampunk World's Fair 2012`}</a>{` (laughingsquid.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=16f65399-a0a0-445f-a88d-a612c62a3c13",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      